// extracted by mini-css-extract-plugin
export var attribution = "G2Quote-module--attribution--c70cf";
export var badge = "G2Quote-module--badge--55f72";
export var content = "G2Quote-module--content--467f8";
export var copy = "G2Quote-module--copy--1e784";
export var cta = "G2Quote-module--cta--00666";
export var emerald = "G2Quote-module--emerald--27258";
export var fadeIn = "G2Quote-module--fadeIn--73d0a";
export var gold = "G2Quote-module--gold--c7895";
export var image = "G2Quote-module--image--ace92";
export var inView = "G2Quote-module--in-view--0e5cc";
export var lilac = "G2Quote-module--lilac--50438";
export var pink = "G2Quote-module--pink--bf6d4";
export var quote = "G2Quote-module--quote--67eb7";
export var section = "G2Quote-module--section--05acb";